"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dgvTheme = void 0;
exports.dgvTheme = {
    logos: {
        memoresaLogoName: "logo_bright.png",
        memoresaLogotypeName: "logotype_bright.png",
        themeLogoName: ["mpv.png"],
    },
    background: { main: "#f1f4f9" },
    primary: { main: "#3d6caa", contrast: "#fff" },
    secondary: { main: "#ff7832", contrast: "#fff" },
    navbar: {
        bg: "#ffffff",
        color: "#3d6caa",
        hover: "#f5b80b",
    },
};
